import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { QuoteBlockData } from '../../../../../models';
import { InputField } from '../../../../InputField';
import { Select } from '../../../../Select';
import { TextAreaField } from '../../../../TextAreaField';
import { CloseWrapper, useBlockToolInputFocus, useNodeAttributeValue } from '../../helpers';

import classes from './QuoteNodeView.module.scss';

export const QuoteNodeView: FunctionComponent<NodeViewProps> = ({
  editor,
  node,
  getPos,
  updateAttributes,
}) => {
  const { t } = useTranslation();

  const { onBlockInputFocus } = useBlockToolInputFocus({ editor, getPos });

  const { text, caption, alignment } = node.attrs as QuoteBlockData;

  const { value: textValue, changeHandler: textChangeHandler } = useNodeAttributeValue({
    value: text,
    onChange: (value) => updateAttributes({ text: value }),
  });

  const { value: captionValue, changeHandler: captionChangeHandler } = useNodeAttributeValue({
    value: caption,
    onChange: (value) => updateAttributes({ caption: value }),
  });

  const items = useMemo(
    () => [
      { id: 'left', title: t('richTextEditor.tools-quote-align-left') },
      { id: 'center', title: t('richTextEditor.tools-quote-align-center') },
    ],
    [t]
  );

  return (
    <NodeViewWrapper as={'div'}>
      <CloseWrapper editor={editor} node={node} getPos={getPos} className={classes['quote']}>
        <TextAreaField
          placeholder={t('richTextEditor.quote-config-text-placeholder')}
          value={textValue}
          onChange={({ target }) => textChangeHandler(target.value)}
          onFocus={onBlockInputFocus}
          minRows={2}
        />
        <InputField
          placeholder={t('richTextEditor.quote-config-author-placeholder')}
          value={captionValue}
          onChange={({ target }) => captionChangeHandler(target.value)}
          onFocus={onBlockInputFocus}
        />
        <Select
          selectedItemId={alignment}
          items={items}
          onChange={(alignment) => updateAttributes({ alignment })}
        />
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
